export const SET_REFERRAL = "SET_REFERRAL";
